// // src/Pages/PriceDispute.js
// import React, { useState, useEffect } from "react";
// import DatePicker from "react-datepicker";
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import "react-datepicker/dist/react-datepicker.css";
// import "./styles/priceDispute.css";


// export default function PriceDispute() {
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [logs, setLogs] = useState([]);
//   const [isRunning, setIsRunning] = useState(false);
//   const [downloadLink, setDownloadLink] = useState(null);

//   const startDispute = async () => {
//     if (!startDate || !endDate) {
//       toast.error("Please select both start and end dates.");
//       return;
//     }

//     setLogs([]);
//     setIsRunning(true);
//     setDownloadLink(null);
//     const formatDate = (date) => {
//       // Adjust for timezone offset to ensure the correct date is sent
//       const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
//       return adjustedDate.toISOString().split('T')[0];
//   };
  
//     const start = formatDate(startDate);
//     const end = formatDate(endDate);
//     const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;

//     try {
//       const response = await fetch(`${baseUrl}/api/start-price-dispute/`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ start_date: start, end_date: end }),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setLogs((prevLogs) => [...prevLogs, data.message]);
//         setDownloadLink(
//           `${baseUrl}/api/download-price-dispute/price_dispute_${start}_${end}.xlsx`
//         );
//       } else {
//         const errorData = await response.json();
//         setLogs((prevLogs) => [...prevLogs, `Error: ${errorData.message}`]);
//         setIsRunning(false);
//       }
//     } catch (error) {
//       setLogs((prevLogs) => [...prevLogs, `Error: ${error.message}`]);
//       setIsRunning(false);
//     }
//   };

//   const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;
//   const stopDispute = async () => {
//     try {
//       const response = await fetch(`${baseUrl}/api/stop-price-dispute/`, {
//         method: "POST",
//       });

//       if (response.ok) {
//         const data = await response.json();
//         setLogs((prevLogs) => [...prevLogs, data.message]);
//       }
//     } catch (error) {
//       setLogs((prevLogs) => [...prevLogs, `Error: ${error.message}`]);
//     } finally {
//       setIsRunning(false);
//     }
//   };

//   return (
//     <div className="price-dispute-page">
//       <h2>Price Dispute Process</h2>

//       <div className="date-picker">
//         <DatePicker
//           selected={startDate}
//           onChange={(date) => setStartDate(date)}
//           selectsStart
//           startDate={startDate}
//           endDate={endDate}
//           placeholderText="Start Date"
//         />
//         <DatePicker
//           selected={endDate}
//           onChange={(date) => setEndDate(date)}
//           selectsEnd
//           startDate={startDate}
//           endDate={endDate}
//           minDate={startDate}
//           placeholderText="End Date"
//         />
//       </div>

//       <div className="actions">
//         <button
//           onClick={startDispute}
//           disabled={isRunning}
//           className="start-button"
//         >
//           {isRunning ? "Running..." : "Start New Price Dispute"}
//         </button>
//         {isRunning && (
//           <button onClick={stopDispute} className="stop-button">
//             Stop
//           </button>
//         )}
//       </div>

//       {downloadLink && (
//         <div className="download-link">
//           <a href={downloadLink} download>
//             Download Dispute Report
//           </a>
//         </div>
//       )}

//       <div className="logs-container">
//         <h3>Logs</h3>
//         <div className="logs">
//           {logs.map((log, index) => (
//             <div key={index} className="log-entry">
//               {log}
//             </div>
//           ))}
//         </div>
//       </div>
//       <ToastContainer />
//     </div>
//   );
// }



import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { toast, ToastContainer } from 'react-toastify';
import "react-datepicker/dist/react-datepicker.css";
import "./styles/priceDispute.css";

export default function PriceDispute() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [logs, setLogs] = useState([]);
    const [isRunning, setIsRunning] = useState(false);
    const [downloadLink, setDownloadLink] = useState(null);
    const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;

    const formatDate = (date) => {
        const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return adjustedDate.toISOString().split('T')[0];
    };

    const startDispute = async () => {
        if (!startDate || !endDate) {
            toast.error("Please select both start and end dates.");
            return;
        }
        const start = formatDate(startDate);
        const end = formatDate(endDate);
        setIsRunning(true);
        setLogs([]); // Clear previous logs

        try {
            const response = await fetch(`${baseUrl}/api/start-price-dispute/`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({ start_date: start, end_date: end }),
            });

            if (response.ok) {
                // Read the response as a stream and handle logs as they arrive
                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');

                reader.read().then(function processText({ done, value }) {
                    if (done) {
                        // Finished reading stream
                        setIsRunning(false);  // Stop process when stream is done
                        setDownloadLink(`${baseUrl}/api/download-price-dispute/?file=price_dispute_${start}_${end}.xlsx`);
                        return;
                    }

                    const text = decoder.decode(value);
                    const logMessages = text.split('\n').filter(line => line.trim() !== '').map(line => line.replace('data:', '').trim());
                    setLogs((prevLogs) => [...prevLogs, ...logMessages]);
                    return reader.read().then(processText);
                });
            } else {
                const errorData = await response.json();
                toast.error(errorData.message);
                setIsRunning(false);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
            setIsRunning(false);
        }
    };

    const stopDispute = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/stop-price-dispute/`, { method: "POST" });
            const data = await response.json();
            if (response.ok) {
                toast.success(data.message);
                setIsRunning(false);
                // Optionally, maintain the download link if the process was manually stopped
                setDownloadLink(downloadLink);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
            setIsRunning(false);
        }
    };

    return (
        <div className="price-dispute-page">
            <h2>Price Dispute Process</h2>
            <div className="date-picker">
                <DatePicker selected={startDate} onChange={setStartDate} selectsStart startDate={startDate} endDate={endDate} placeholderText="Start Date" />
                <DatePicker selected={endDate} onChange={setEndDate} selectsEnd startDate={startDate} endDate={endDate} minDate={startDate} placeholderText="End Date" />
            </div>
            <div className="actions">
                <button onClick={startDispute} disabled={isRunning} className="start-button">
                    {isRunning ? "Processing..." : "Start New Price Dispute"}
                </button>
                <button onClick={stopDispute} disabled={!isRunning} className="stop-button">
                    Stop Dispute
                </button>
                <button disabled={!downloadLink || isRunning} className="download-button">
                    {downloadLink ? <a href={downloadLink} download>Download Dispute Report</a> : "Download Dispute Report"}
                </button>
            </div>
            <div className="logs-container">
                <h3>Logs</h3>
                <div className="logs">
                    {logs.map((log, index) => (
                        <div key={index} className="log-entry">{log}</div>
                    ))}
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}
